"use strict";

exports.__esModule = true;
exports.legacyTheme = void 0;
var legacyTheme = {
  colors: {
    fill: {
      green: {
        '100': '#C3E1D2',
        '200': '#93C9AE',
        '300': '#62B08B',
        '400': '#329867',
        '500': '#0E864C',
        '600': '#0B6B3D',
        '700': '#095731',
        '800': '#074326',
        '900': '#06361E'
      },
      mint: {
        '100': '#C7DFDF',
        '200': '#A5CCCC',
        '300': '#77B3B3',
        '400': '#4A9999',
        '500': '#1D8080',
        '600': '#196D6D',
        '700': '#145A5A',
        '800': '#104646',
        '900': '#0C3333'
      },
      orange: {
        '100': '#FBE2CC',
        '200': '#F7C699',
        '300': '#F4A966',
        '400': '#F08D33',
        '500': '#EC7000',
        '600': '#C95F00',
        '700': '#A54E00',
        '800': '#823E00',
        '900': '#532700'
      },
      pink: {
        '100': '#F5D2E2',
        '200': '#EBA8C7',
        '300': '#E081AD',
        '400': '#D65D95',
        '500': '#CC3B7F',
        '600': '#A32F65',
        '700': '#7A234C',
        '800': '#621C3D',
        '900': '#49152E'
      },
      purple: {
        '100': '#DDD0F3',
        '200': '#BBA1E7',
        '300': '#9166D9',
        '400': '#6F36CD',
        '500': '#5613C4',
        '600': '#4910A7',
        '700': '#3C0D89',
        '800': '#2F0A6C',
        '900': '#22084E'
      },
      red: {
        '100': '#F4CFCD',
        '200': '#ECA9A5',
        '300': '#E3837D',
        '400': '#DA5D55',
        '500': '#D44037',
        '600': '#B4362F',
        '700': '#942D27',
        '800': '#75231E',
        '900': '#551A16'
      },
      yellow: {
        '100': '#FFF2CE',
        '200': '#FFE59D',
        '300': '#FFD86C',
        '400': '#FFCB3B',
        '500': '#FFBE0B',
        '600': '#CC9808',
        '700': '#A37907',
        '800': '#7A5B05',
        '900': '#5C4404'
      }
    },
    neutral: {
      '100': '#F4F4F5',
      '200': '#D5D7D9',
      '300': '#B8BBBF',
      '400': '#9DA1A6',
      '500': '#80858C',
      '600': '#646B72',
      '700': '#49515A',
      '800': '#2A343F',
      '900': '#0A1521'
    },
    primary: {
      '100': '#C9E1FB',
      '200': '#95C5F8',
      '300': '#62A9F4',
      '400': '#308DF1',
      '500': '#0072EC',
      '600': '#005CBE',
      '700': '#00458E',
      '800': '#003772',
      '900': '#002956'
    },
    status: {
      danger: {
        '100': '#FCE9E4',
        '200': '#F3B6A3',
        '300': '#EA8161',
        '400': '#E15124',
        '500': '#DD3906',
        '600': '#C33306',
        '700': '#8D2504',
        '800': '#511503'
      },
      success: {
        '100': '#E1F2E6',
        '200': '#9DD2AB',
        '300': '#5FB676',
        '400': '#1E983F',
        '500': '#018A26',
        '600': '#017821',
        '700': '#015718',
        '800': '#01320E'
      },
      warning: {
        '100': '#FDF3E5',
        '200': '#F6D4A1',
        '300': '#EFB660',
        '400': '#E89922',
        '500': '#E58A02',
        '600': '#CE7C02',
        '700': '#915702',
        '800': '#543301'
      }
    }
  },
  radii: {
    none: 0,
    small: 0,
    medium: 0,
    large: 0,
    full: 9999
  },
  shadows: {
    small: '',
    medium: '',
    large: '',
    'x-large': '5.0px 10.0px 10.0px 0px rgba(0, 0, 0, 0.1),0.0px 2.0px 10.0px 4.0px rgba(0, 0, 0, 0.1)'
  }
};
exports.legacyTheme = legacyTheme;